"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if given value is defined.
 *
 * @export
 * @class IsDefinedValidator
 * @implements {PropertyValidator<any>}
 */
class IsDefinedValidator {
    isValid(input) {
        return typeof input !== "undefined";
    }
}
exports.IsDefinedValidator = IsDefinedValidator;
//# sourceMappingURL=IsDefinedValidator.js.map